<template>
    <row>
        <column cols="12">
            <form-input v-model="props.data.email"
                        :label="$t('label.your_email')"
                        :name="`${props.namePrefix}email`"
                        type="email"
                        :disabled="props.disabled" :inverted="props.inverted"
                        :rules="{required: true, min: 4, max: 190}"/>
        </column>
        <column cols="12" lg="6">
            <form-input v-model="props.data.first_name"
                        :rules="{required: true, min: 2, max: 50}"
                        :disabled="props.disabled" :inverted="props.inverted"
                        :label="$t('label.your_first_name')"
                        :name="`${props.namePrefix}first_name`"/>
        </column>
        <column cols="12" lg="6">
            <form-input v-model="props.data.last_name"
                        :label="$t('label.your_last_name')"
                        :name="`${props.namePrefix}last_name`"
                        :rules="{required: true, min: 2, max: 50}"
                        :disabled="props.disabled" :inverted="props.inverted">
            </form-input>
        </column>
        <slot/>
        <column cols="12">
            <form-input v-model="props.data.password" :rules="{required: true, min: 6, max: 100}"
                        :disabled="props.disabled" :inverted="props.inverted" :label="$t('label.password')" type="password" :name="`${props.namePrefix}password`"/>
        </column>

        <column cols="12">
            <form-input v-model="props.data.password_confirmation"
                        :disabled="props.disabled" :inverted="props.inverted" :rules="{required: true, min: 6, max: 100, equal: data.password}" :label="$t('label.password_confirmation')" type="password"
                        :name="`${props.namePrefix}password_confirmation`"/>
        </column>

        <column cols="12">
            <form-checkbox v-model="props.data.gtc" :name="`${props.namePrefix}gtc`" :rules="{accepted: true}" :disabled="props.disabled">
                <div class="text-sm text-left">
                    <div v-html="gtc ? gtc : $t('text.account_gtc')"/>
                    <span>
                       <a @click.prevent="globalStore.showGtcModal" :style="{color: props.color}">{{ $t('action.open_gtc') }}</a> /
                       <a @click.prevent="globalStore.showPrivacyPolicyModal" :style="{color: props.color}">{{ $t('action.open_privacy_policy') }}</a>
                    </span>
                </div>
            </form-checkbox>
        </column>
    </row>
</template>

<script setup lang="ts">
import {type FormInputsProps} from "../../../types/form";
import {useGlobalStore} from "../../../store/global";

const props = withDefaults(defineProps<{
	gtc?: string,
	inverted?: boolean,
	color?: string,
	namePrefix?: string
} & FormInputsProps>(), {
	namePrefix: ''
});

const globalStore = useGlobalStore();

</script>